import React from 'react';
import { CollapsableWrap } from './CollapsableWrap';
import { ContentWrap } from './ContentWrap';
import { Collapsable } from './Collapsable';

export default function WithCollapsable({ content, collapsedContent, controllerData }) {
  const { isOpened } = controllerData;

  return (
    <CollapsableWrap>
      <ContentWrap isOpened={!isOpened}>
        {content(controllerData)}
      </ContentWrap>

      <Collapsable isOpened={isOpened}>
        {collapsedContent(controllerData)}
      </Collapsable>
    </CollapsableWrap>
  )
};
